module.exports = __webpack_public_path__ + "img/index-ph1.39b8cf80.png";